import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from "./Subpages/Header.tsx";
import Home from "./Subpages/Home.tsx";
import Contact from "./Subpages/Contact.tsx";
import Footer from "./Subpages/Footer.tsx";
import AboutUs from "./Subpages/AboutUs.tsx";
import Services from "./Subpages/Services.tsx";
import Pricing from "./Subpages/Pricing.tsx";
import LegalDisclaimer from "./Subpages/LegalDisclaimer.tsx";

const App: React.FC = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-grow">
          <Routes>
            {/* Home is now the default route */}
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/legal" element={<LegalDisclaimer />} />

            {/* Redirect any unknown routes to Home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
